<app-top-header *ngIf="!isUserLoggedIn"></app-top-header>
<app-home-custom-top-header *ngIf="isUserLoggedIn"></app-home-custom-top-header>
<app-comman-header></app-comman-header>
<div style="background-image: url(../../../assets/media/bg/bg-10.jpg)" class="main"></div>
<div class="col-lg-12">
    <div class="card card-custom gutter-b card-stretch p-4 p-sm-10" style="top: 30px">
        <div class="card-body">
            <div class="container">
                <div class="mews_SecHead">
                    <h1><strong> WE ARE SORRY...</strong></h1>
                    <p>THE PAGE YOU'RE TRING TO REACH HAS RISTRICTED ACCESS.</p>
                    <p>PLEASE CONTACT YOUR ADMINISTRATOR.</p>
                </div>
                <div>
                    <br />

                    <div class="row" style="display: flex; justify-content: center">
                        <div class="read_more">
                            <button (click)="backurl()" class="btn primary-ebtn py-3"><i class="fa fa-share-square"
                                    aria-hidden="true"></i> back</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>